import { render } from "./JobPlacementPage.vue?vue&type=template&id=2cbaf5c3&scoped=true"
import script from "./JobPlacementPage.vue?vue&type=script&lang=js"
export * from "./JobPlacementPage.vue?vue&type=script&lang=js"

import "./JobPlacementPage.vue?vue&type=style&index=0&id=2cbaf5c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbaf5c3"]])

export default __exports__